<mat-dialog-content>
    <mat-progress-bar mode="buffer" *ngIf="loading"></mat-progress-bar>

    <div class="images" *ngIf="!loading">
        <img *ngFor="let image of photos" height="400px" [src]="image" (click)="showImage(image)">
    </div>
</mat-dialog-content>